import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Box, TextField, Button } from '@material-ui/core';
import {
  setSystemErrorType, setSystemLodingFLg, setInitMessage,
  setErrorMessage, authenticate, getUserInfo, getContractLabel, getCsrfToken,
  setInflowType, setPasswordPopFlg, checkExpirationDate, setAuthErrorFlg, setMultiLoginFlg,
} from '../../actions/CommonAction';
import { setInitCompanyState } from '../../actions/CompanyAction';
import { setInitTargetState } from '../../actions/TargetAction';
import { setInitUploadState } from '../../actions/UploadAction';
import { setInitMatchingState } from '../../actions/MatchingAction';
import { setInitUserManagedState } from '../../actions/UserManagedAction';
import { setInitLogOutputState } from '../../actions/LogOutputAction';
import { setInitExternalDataHistoryState, setInitExternalDataSendHistoryState } from '../../actions/ExternalDataHistoryAction';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import {
  INPUT, ROLE_CODE, SYSTEM_ERROR_TYPE, RESULT_CODE,
} from '../../../common/const';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import './LoginComponent.css';
import MessageArea from '../MessageArea';
import Processing from '../Processing';
import TitleVideo from '../../../movie/50per.mp4';
import LogoIcon from '../../../image/logo.svg';

/**
 * ログイン画面コンポーネント
 */
class LoginComponent extends Component {
  constructor() {
    super();
    this.state = {
      userIdErrFlag: false,
      userIdErrMsg: '',
      passwordErrFlag: false,
      passwordErrMsg: '',
    };
  }

  componentDidMount = () => {
    // Google Analytics
    window.gtagPageview();

    const {
      setInitCompanyStateAct,
      setInitTargetStateAct,
      setInitUploadStateAct,
      setInitMatchingStateAct,
      setInitUserManagedStateAct,
      setInitLogOutputStateAct,
      setInitExternalDataSendHistoryStateAct,
      setInitExternalDataHistoryStateAct,
      getCsrfTokenAct,
    } = this.props;
    // state初期化
    setInitCompanyStateAct();
    setInitTargetStateAct();
    setInitUploadStateAct();
    setInitMatchingStateAct();
    setInitUserManagedStateAct();
    setInitLogOutputStateAct();
    setInitExternalDataSendHistoryStateAct();
    setInitExternalDataHistoryStateAct();
    getCsrfTokenAct();
  }

  componentWillUnmount() {
    const { setAuthErrorFlgAct, setMultiLoginFlgAct } = this.props;
    setAuthErrorFlgAct(false);
    setMultiLoginFlgAct(false);
  }

  /**
   * ログイン処理
   */
  login = async () => {
    const {
      setSystemErrorTypeAct,
      setSystemLodingFLgAct,
      setErrorMessageAct,
      authenticateAct,
      getUserInfoAct,
      setInflowTypeAct,
      setPasswordPopFlgAct,
      checkExpirationDateAct,
    } = this.props;
    setSystemErrorTypeAct(SYSTEM_ERROR_TYPE.SUCCESS);
    // ユーザID、パスワードの取得
    const userId = document.getElementById('userId').value;
    const password = document.getElementById('password').value;
    const msgs = [];
    // ユーザIDの入力チェック
    const checkUserIdResult = validator.checkRequired(INPUT.LOGIN.USER_ID, userId, msgs);
    // パスワードの入力チェック
    const checkPasswordResult = validator.checkRequired(INPUT.LOGIN.PASSWORD, password, msgs);
    // 入力エラーがあった場合は認証処理を行わず、画面にメッセージを表示
    if (msgs.length !== 0) {
      this.setState({
        userIdErrFlag: !checkUserIdResult,
        passwordErrFlag: !checkPasswordResult,
      });
      setErrorMessageAct(msgs);
    } else {
      // エンターキー連打制御
      document.activeElement.blur();
      setSystemLodingFLgAct(true);
      const { history } = this.props;
      // ユーザ認証処理
      if (await authenticateAct(userId, password)) {
        // パスワード有効期限チェック
        const ret = await checkExpirationDateAct();
        if (ret.result !== RESULT_CODE.SUCCESS) {
          setSystemLodingFLgAct(false);
          return;
        }
        if (ret.response.result_code === '1') {
          // パスワードの有効期限が切れていたらパスワード変更POPUP表示
          setInflowTypeAct('1');
          setPasswordPopFlgAct(true);
          setSystemLodingFLgAct(false);
          return;
        }
        // ユーザー情報取得
        const userInfo = await getUserInfoAct();

        // ユーザ認証が正常に完了した場合、各画面へ遷移
        if (userInfo && userInfo.role_list) {
          if (userInfo.role_list.indexOf(ROLE_CODE.COMPANY) >= 0) history.push('/searchcompany');
          else if (userInfo.role_list.indexOf(ROLE_CODE.TARGET) >= 0) history.push('/targetcompany');
          else if (userInfo.role_list.indexOf(ROLE_CODE.MATCHING) >= 0) history.push('/matchingcompany');
          else if (userInfo.role_list.indexOf(ROLE_CODE.UPLOAD) >= 0 && userInfo.transaction_contact === 1) history.push('/uploadcompanyinfo');
          else if (userInfo.role_list.indexOf(ROLE_CODE.USERMANAGED) >= 0) history.push('/usermanaged');
          else if (userInfo.role_list.indexOf(ROLE_CODE.LOGOUTPUT) >= 0) history.push('/logoutput');
          else if (userInfo.role_list.indexOf(ROLE_CODE.EXTERNALDATA) >= 0 && (userInfo.businesscard_contact === 1 || userInfo.common_contract === 1)) history.push('/externaldata');
          else history.push('/error');
        } else { history.push('/error'); }
      } else {
        const { systemErrorType } = this.props;
        if (systemErrorType === SYSTEM_ERROR_TYPE.CSRF_NONE
          || systemErrorType === SYSTEM_ERROR_TYPE.CLOSE) {
          // CSRFトークン無効または閉塞中の場合、エラー画面に遷移
          history.push('/error');
        } else if (systemErrorType === SYSTEM_ERROR_TYPE.AUTH_NG) {
          // ユーザ認証でエラーが発生した場合、エラーメッセージを表示
          msgs.push(<div key="error-1">{ERROR.E00001}</div>);
          setErrorMessageAct(msgs);
        } else {
          // それ以外の場合はシステムエラーとして処理
          msgs.push(<div key="error-1">{ERROR.E09010}</div>);
          setErrorMessageAct(msgs);
        }
      }
      setSystemLodingFLgAct(false);
    }
  }

  /**
   * ユーザーIDのチェック
   */
  checkUserId = () => {
    const { setInitMessageAct, setAuthErrorFlgAct, setMultiLoginFlgAct } = this.props;
    setInitMessageAct();
    setAuthErrorFlgAct(false);
    setMultiLoginFlgAct(false);
    // ユーザID、パスワードの取得
    const userId = document.getElementById('userId').value;
    const msgs = [];
    // ユーザIDの入力チェック
    validator.checkMaxLength(userId, 20, msgs);
    validator.checkChar(userId, VALIDATOR_CONST.PATERN_ALPHABET_NUM, msgs);
    // 入力エラーがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      this.setState({
        userIdErrFlag: true,
        userIdErrMsg: getMessage(ERROR.E08009, msgs.join(',')),
      });
      return false;
    }
    this.setState({
      userIdErrFlag: false,
      userIdErrMsg: '',
    });
    return true;
  }

  /**
   * パスワードのチェック
   */
  checkPassword = () => {
    const { setInitMessageAct, setAuthErrorFlgAct, setMultiLoginFlgAct } = this.props;
    setInitMessageAct();
    setAuthErrorFlgAct(false);
    setMultiLoginFlgAct(false);
    // ユーザID、パスワードの取得
    const password = document.getElementById('password').value;
    const msgs = [];
    // ユーザIDの入力チェック
    validator.checkMaxLength(password, 30, msgs);
    validator.checkChar(password, VALIDATOR_CONST.PATERN_PASSWORD, msgs);
    // 入力エラーがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      this.setState({
        passwordErrFlag: true,
        passwordErrMsg: getMessage(ERROR.E08009, msgs.join(',')),
      });
      return false;
    }
    this.setState({
      passwordErrFlag: false,
      passwordErrMsg: '',
    });
    return true;
  }

  render() {
    const {
      userIdErrFlag,
      userIdErrMsg,
      passwordErrFlag,
      passwordErrMsg,
    } = this.state;
    return (
      <div className="login">
        <Box className="logo">
          <img alt="logoIcon" src={LogoIcon} />
        </Box>
        <Box className="form">
          <Box className="form-inner">
            <Box>
              <Box className="title-row">
                <Box>
                  <span className="title-emphasis">ワンストップ</span>
                  <span className="title-normal">で</span>
                  <span className="title-emphasis">取引先の名寄せ</span>
                  <span className="title-normal">と</span>
                </Box>
                <Box>
                  <span className="title-emphasis">ターゲットリスト</span>
                  <span className="title-emphasis">作成</span>
                  <span className="title-normal">を</span>
                  <span className="title-emphasis">実現！</span>
                </Box>
              </Box>
              <MessageArea />
              <Box className="loginid-field">
                <Box className="label">ログイン ID</Box>
                <Box className="value">
                  <TextField
                    id="userId"
                    onKeyDown={
                      !passwordErrFlag
                        ? (ev) => {
                          if (ev.key === 'Enter') {
                            if (this.checkUserId()) this.login();
                          }
                        } : null
                    }
                    onBlur={this.checkUserId}
                    error={userIdErrFlag}
                  />
                  <span className="error-right">{userIdErrMsg}</span>
                </Box>
              </Box>
              <Box className="password-field">
                <Box className="label">パスワード</Box>
                <Box className="value">
                  <TextField
                    type="password"
                    id="password"
                    onKeyDown={
                      !userIdErrFlag
                        ? (ev) => {
                          if (ev.key === 'Enter') {
                            if (this.checkPassword()) this.login();
                          }
                        } : null
                    }
                    onBlur={this.checkPassword}
                    error={passwordErrFlag}
                  />
                  <span className="error-right">{passwordErrMsg}</span>
                </Box>
              </Box>
              <Button
                className={
                  !userIdErrFlag && !passwordErrFlag
                    ? 'button-normal-color' : 'button-normal-disabled'
                }
                onClick={
                  !userIdErrFlag && !passwordErrFlag
                    ? this.login : null
                }
                disabled={userIdErrFlag || passwordErrFlag}
              >
                ログイン
              </Button>
            </Box>
            <Box className="login-footer">
              <div className="copyright">
                © TOKYO SHOKO RESEARCH, LTD.
              </div>
            </Box>
          </Box>
        </Box>
        <Box className="login-video">
          <video src={TitleVideo} autoPlay loop muted playsInline />
        </Box>
        <Processing />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    systemErrorType: state.common.systemErrorType,
  }),
  (dispatch) => ({
    setSystemErrorTypeAct: (errorType) => dispatch(setSystemErrorType(errorType)),
    setSystemLodingFLgAct: (systemLodingFLg) => dispatch(setSystemLodingFLg(systemLodingFLg)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setErrorMessageAct: (messages) => dispatch(setErrorMessage(messages)),
    authenticateAct: (userId, password) => dispatch(authenticate(userId, password)),
    getUserInfoAct: () => dispatch(getUserInfo()),
    getContractLabelAct: () => dispatch(getContractLabel()),
    getCsrfTokenAct: () => dispatch(getCsrfToken()),
    setInitCompanyStateAct: () => dispatch(setInitCompanyState()),
    setInitTargetStateAct: () => dispatch(setInitTargetState()),
    setInitUploadStateAct: () => dispatch(setInitUploadState()),
    setInitMatchingStateAct: () => dispatch(setInitMatchingState()),
    setInitUserManagedStateAct: () => dispatch(setInitUserManagedState()),
    setInitLogOutputStateAct: () => dispatch(setInitLogOutputState()),
    setInitExternalDataSendHistoryStateAct: () => dispatch(setInitExternalDataSendHistoryState()),
    setInitExternalDataHistoryStateAct: () => dispatch(setInitExternalDataHistoryState()),
    setInflowTypeAct: (inflowType) => dispatch(setInflowType(inflowType)),
    setPasswordPopFlgAct: (bool) => dispatch(setPasswordPopFlg(bool)),
    checkExpirationDateAct: () => dispatch(checkExpirationDate()),
    setAuthErrorFlgAct: (bool) => dispatch(setAuthErrorFlg(bool)),
    setMultiLoginFlgAct: (bool) => dispatch(setMultiLoginFlg(bool)),
  }),
)(withRouter(LoginComponent));
